import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

import type { UpdateAdUnitsMutation, UpdateAdUnitsMutationVariables } from 'gql/graphql'

export const UPDATE_AD_UNIT_PRODUCT_ENABLED: TypedDocumentNode<
  UpdateAdUnitsMutation,
  UpdateAdUnitsMutationVariables
> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnits($input: UpdateAdUnitsInput!) {
    updateAdUnits(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
